<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><a id="page_v">For the creators of their own destinies.</a></p><a id="page_v">
</a><p class="ded"><a id="page_v">May your adventure jars always be full.</a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?579010ba